import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
} from '@tanstack/react-query'
import { RequestTypes, permitsKeys } from '@core/react-query/features/permits'
import { PageResponse } from '@core/entities/pagination'
import { usePageableQuery } from '@core/react-query/hooks'
import { IPermitBase, PermitBase } from '@core/entities/permit/PermitBase'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const dataTransformer = ({ content }: PageResponse<IPermitBase>) => {
  return content.map((permit) => PermitBase.new(permit))
}

export const useGetEligibleParentsInfinite = (
  payload: RequestTypes['getEligibleParents'],
  options: UseInfiniteQueryOptions<
    PageResponse<IPermitBase>,
    RequestErrorType,
    Array<PermitBase>
  > = {},
) => {
  const eligibleParentsQuery = permitsKeys.eligibleParents(payload)

  const infiniteQueryOptions = usePageableQuery({
    queryEnabled: options.enabled,
    queryKey: eligibleParentsQuery.queryKey,
    dataTransformer,
  })

  return useInfiniteQuery<
    PageResponse<IPermitBase>,
    RequestErrorType,
    Array<PermitBase>
  >({
    ...infiniteQueryOptions,
    ...eligibleParentsQuery,
    ...options,
  })
}
